import { Experience } from '../types';

export const experience: Experience[] = [
    {
        id: 1,
        company: 'Freespace',
        position: 'Senior Software Engineer',
        duration: 'Mar 2020 - Present',
        location: 'Remote',
        description: 'Leading development of enterprise-grade cloud-native applications with focus on microservices architecture, serverless solutions, and secure authentication systems. Architecting scalable SaaS platforms serving multiple enterprise clients.',
        technologies: ['React.js', 'Node.js', 'TypeScript', 'AWS Lambda', 'Spring Boot', 'DynamoDB', 'MySQL', 'Redis', 'Single-SPA', 'Serverless Framework'],
        achievements: [
            'Architected Freespace Portal with micro frontend architecture achieving 100/100 Mozilla HTTPS Observatory security score',
            'Designed serverless auth system reducing infrastructure costs by 65% and improving performance by 35%',
            'Led enterprise authentication implementation becoming the team\'s go-to expert for SAML and OIDC',
            'Integrated multiple 3rd party services including Genetec, Zoom, Office 365, Slack, and Serraview',
            'Received Freespace Diver Award for innovative thinking and Monday Crusher MVP for outstanding performance',
            'Mentored junior developers and fostered collaborative team environment'
        ]
    },
    {
        id: 2,
        company: 'Previous Experience',
        position: 'Full Stack Developer',
        duration: '2019 - 2020',
        location: 'India',
        description: 'Developed full-stack web applications using modern technologies. Gained experience in cloud platforms, database design, and API development while building scalable solutions for various business domains.',
        technologies: ['React', 'Node.js', 'JavaScript', 'Java', 'MySQL', 'MongoDB', 'AWS', 'Git'],
        achievements: [
            'Built multiple full-stack applications with focus on performance and scalability',
            'Implemented RESTful APIs and database optimization strategies',
            'Collaborated with cross-functional teams to deliver high-quality software solutions',
            'Gained expertise in cloud technologies and DevOps practices'
        ]
    }
]; 